import { Twitch } from 'lucide-react';

export const Header = () => (
  <header className="relative z-10 border-b-4 border-gray-300 bg-black/90 backdrop-blur-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl sm:text-3xl font-black game-show-text">
          CIRO GAME SHOW
        </h1>
        <a 
          href="https://www.twitch.tv/CiroGameShowTwitch"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-500 rounded-lg font-bold transition-all hover:scale-105 live-indicator"
        >
          <Twitch className="w-5 h-5" />
          <span className="hidden sm:inline">WATCH LIVE</span>
        </a>
      </div>
    </div>
  </header>
);
